import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { useAuth } from 'providers/auth';
import ContactApi from 'api/contact';
import AlertHelper from 'helpers/AlertHelper';

const RequestBotButton = ({ className = 'btn btn-primary btn-lg' }) => {
  const { t } = useTranslation();
  const { me } = useAuth();
  const [requesting, setRequesting] = useState(false);

  const requestButtonText = requesting ? t('actions.requesting') : t('explore.actions.request_custom');

  const handleRequestBot = async () => {
    const result = await AlertHelper.confirm({
      title: 'Solicitar Robô Customizado',
      text: 'Descreva um pouco do que você precisa.',
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off',
        required: true,
      },
    });

    if (result.value) {
      setRequesting(true);

      try {
        await ContactApi.create({
          type: 'demo',
          company: me.company_id,
          name: me.name,
          email: me.email,
          phone: '-',
          message: result.value,
        });

        Swal.fire(
          'Robô customizado solitado!',
          `Você solicitou um robô customizado. Por favor, aguarde que em breve nossa equipe irá entrar em contato com você.`,
          'success'
        );
      } catch (error) {
        console.error('ERROR', error);
        Swal.fire('Ops!', 'Ocorreu um erro ao solicitar a contratação.', 'error');
      } finally {
        setRequesting(false);
      }
    }
  };

  return (
    <div>
      <button disabled={requesting} className={className} onClick={handleRequestBot}>
        {requestButtonText}
      </button>
    </div>
  );
};

export default RequestBotButton;
